import styled, { css } from 'styled-components';

export const ContactStyles = styled.div`
  margin-top: ${({ mt }) => mt}px;
`;

export const ContactsContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;

  @media (max-width: 512px) {
    padding: 16px 9px;
  }
`;

export const InfoAndButtonWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 512px) {
    flex-direction: column;
    align-items: flex-start;

    .write-button {
      margin-left: 14px;
    }
  }
`;

export const Avatar = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.weakBlue};
  background-image: url(${({ src }) => src});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  &::before {
    position: absolute;
    display: block;
    border-radius: 50%;
    top: 0px;
    right: 0px;
    content: '';
    width: 12px;
    height: 12px;
    border: 3px solid ${({ theme }) => theme.colors.color_white};
    ${({ status, theme }) => {
      if (status) {
        return css`
          background-color: ${theme.colors.color_green};
        `;
      }
      return css`
        background-color: ${theme.colors.color_gray};
      `;
    }}
  }
  ${({ status, theme }) =>
    !status
      ? css`
          &::after {
            position: absolute;
            content: '';
            display: block;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            top: 6px;
            right: 6px;
            background-color: ${theme.colors.color_white};
          }
        `
      : ''}
`;

export const Info = styled.div`
  flex-grow: 1;
  margin-left: 10px;

  @media (max-width: 512px) {
    margin-bottom: 10px;
    margin-left: 10px;
  }
`;

export const NameWrapper = styled.div`
  display: flex;
  margin-left: 4px;
`;

export const Name = styled.span`
  font-weight: bold;
  margin-right: 4px;
`;

export const ConfirmedWrapper = styled.div`
  width: fit-content;
`;

export const Confirmed = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--glz-color-primary);
  background-color: var(--glz-color-primary-tone-3);
  padding: 4px 8px 4px 4px;
  border-radius: 4px;
  font-size: ${({ theme }) => theme.fontSize.sm};
  margin-top: 4px;
  height: 24px;
  box-sizing: border-box;
`;

export const Status = styled.span`
  align-self: start;
  font-size: ${({ theme }) => theme.fontSize.sm};
  ${({ status, theme }) => {
    if (status) {
      return css`
        font-weight: bold;
        color: ${theme.colors.color_green};
      `;
    }
    return css`
      color: ${theme.colors.color_gray};
    `;
  }}
`;

export const ButtonContainer = styled.div``;
